import { ITabletData } from "api/types";
import Text from "components/common/Text/Text";
import * as React from "react";
import styled from "styled-components";

const FixedBottomText = styled(Text)`
  position: fixed;
  bottom: 20px;
  right: 20px;
  color: lightgray;
`;

interface IProps {
  version: string;
  tabletData?: ITabletData;
}

const TabletInfoAnnotation = ({ version, tabletData }: IProps) => (
  <FixedBottomText>
    {version}
    {tabletData &&
      `-${tabletData.tabletId.substring(
        0,
        8
      )}-${tabletData.operationMode.substring(0, 1)}`}
  </FixedBottomText>
);

export default TabletInfoAnnotation;



// WEBPACK FOOTER //
// ./src/components/common/TabletInfoAnnotation/TabletInfoAnnotation.tsx